import { ReadonlyInputModel } from './ReadonlyInput.model';
import React, { useMemo } from 'react';
import css from './ReadonlyInput.module.scss';
import { LinkButton, Text } from '@epam/uui';

export const ReadonlyInput = ({
  value,
  isTitle = false,
  isLink = false,
  label = 'text',
}: ReadonlyInputModel) => {
  const datatestid = useMemo(
    () => `${label.toLowerCase().replaceAll(' ', '-')}-readonly-input`,
    [label],
  );

  if (isLink && typeof value === 'string') {
    return (
      <LinkButton
        caption={value}
        color="primary"
        cx={css['readonly-text']}
        href={value}
        rawProps={{
          'data-testid': datatestid,
        }}
      />
    );
  }

  return (
    <Text
      cx={{
        [css['readonly-text']]: true,
        [css['readonly-text_title']]: isTitle,
      }}
      fontSize="14"
      lineHeight="18"
      rawProps={{
        'data-testid': datatestid,
      }}>
      {value}
    </Text>
  );
};
